import { formatUrl } from "../../_helpers/parseurl";

export const Recommendation = ({data}) => {

    const handleNav = (e) => {
        e.preventDefault();
    }

    return (
        <div className="rec-conatiner">
            {data?.map((datum,k) => {
                return (
                    <div className="rec-unit-container" key={k}>
                        <button className="rec-unit" onClick={() =>{ handleNav()}}>
                            <span className="reason-txt">{datum.recommendedCourse}</span>
                            <img 
                                src={formatUrl(datum?.courseData?.poster)}
                                alt=""
                                className="sm-course-poster"
                            />
                        </button>
                        <div className="rec-reason">{datum.reason}</div>
                    </div>
                )
            })}
        </div>
    )
}
